import React from "react";
import { NavLink } from "react-router-dom";
import direction from "../../../service/direction.json";
const VOP = () => {
  return (
    <div className="form-group row col-md-12 text-justify">
      <div className="col-md-6">
        <div style={{ width: "18rem;", fontSize: "20px" }}>
          <div className="card-body">
            <h5 className="card-title text-bold" style={{ fontSize: "30px" }}>
              تلفن ثابت ابری
            </h5>
            <p className="card-text">
              در سایه بان سرویس جدیدی با عنوان تلفن ثابت ابری یا همان تلفن
              اینترنتی ارائه میشود که خط تلفن ثابت مجازی از پیش شماره هر شهر
              دلخواه میتوانید تهیه کرده و از امکانات تلفن سانترال بصورت مجازی و
              بدون هیچ تجهیزاتی استفاده کنید مانند تعریف داخلی های مختلف، صف
              تماس، ارسال فکس و حتی برقراری تماس خروجی
            </p>
            <div className="text-center">
              <NavLink to="/VOPInfo" className="btn btn-info">
                تلفن ثابت اینترنتی
              </NavLink>
            </div>
          </div>
        </div>
      </div>
      <div className="col-md-6 text-center">
        <img
          src={`${direction.ImgDesign}whats-cloud-phone.jpg`}
          alt="سایه بان"
        />
      </div>
    </div>
  );
};

export default VOP;
